<template>
    <div>
        <b-card v-show="editMode===0">
            <b-row>
                <b-col sm="12" class="text-right">
                    <b-btn-group size="sm">
                        <b-button variant="white" class="button-icon-only mr-1" title="Обновить"
                                  @click="buttonRefreshClicked"
                        >
                            <i class="fa fa-sync"/>
                        </b-button>
                        <b-button v-show="userActionAccessArray['new']" variant="success" @click="buttonAddClicked">
                            <i class="fa fa-plus"/> Новая запись
                        </b-button>
                    </b-btn-group>
                </b-col>
            </b-row>
            <MyToolbar>
                <MyToolbarItem>
                    <b-input v-model="searchQuickFilter" @keyup.prevent.enter="buttonSearchClicked" maxlength="200"
                             size="sm" placeholder="Поиск..." ref="inputQuickFilter" @keyup.esc="searchQuickFilter=''"
                    />
                </MyToolbarItem>
                <MyToolbarItem>
                    <b-button size="sm" variant="secondary" @click="buttonSearchClicked">Поиск</b-button>
                    <b-button size="sm" :variant="sortMode===0 ? 'secondary' : 'primary'" title="Расширенный поиск"
                              class="button-icon-only-normal ml-2"
                              @click="buttonAdvSearchShowClicked"
                    >
                        <i class="fas fa-cog"/>
                    </b-button>
                </MyToolbarItem>
            </MyToolbar>

            <b-alert :show="err" :variant="errVariant" class="mb-4">{{errText}}</b-alert>

            <b-table outlined hover head-variant="light" :fields="departmentListFields" :items="departmentList"
                     responsive="responsive" :no-local-sorting="true" sort-by="Department"
                     @row-clicked="tableRowClicked"
                     @sort-changed="sortChanged"
            >
            </b-table>
            <b-row>
                <b-col sm="6">
                    <b-pagination first-number last-number
                                  v-model="recordCurrentPageNumber" @input="loadDepartmentList"
                                  :total-rows="recordTotalNumber" :per-page="recordCountPerPage"
                    />
                </b-col>
                <b-col sm="6">
                    <div class="custom-items-per-page-div">
                        <label>Показать записей:</label>
                        <b-form-select id="input-records-per-page" size="sm" style="margin-left: 10px;width:65px"
                                       :options="recordCountPerPageArray" v-model="recordCountPerPage"
                                       @change="loadDepartmentList"
                        />
                    </div>
                </b-col>
            </b-row>

        </b-card>
        <b-card v-show="editMode===1" :title="addEditTitle">
            <b-alert :show="err" :variant="errVariant" class="mb-3">{{errText}}</b-alert>
            <b-form @submit.prevent="saveRecord" @reset.prevent="cancelRecord">
                <b-row>
                    <b-col md="12" v-if="userActionAccessCompany">
                        <b-form-group label="РЭК" label-for="select-edit-department" class="required">
                            <b-select id="select-edit-department" :options="editCompanies" v-model="editCompanyUid"
                                      ref="selectEditCompany" :disabled="recordUid.length!==0"
                                      @change="loadEditDepartmentTypes"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group v-if="userActionAccessRes" label="РЭС" label-for="select-edit-res"
                                      class="required">
                            <b-select id="select-edit-res" :options="editRes" v-model="editResUid"
                                      ref="selectEditRes"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="Вид подразделения" label-for="select-edit-department-type"
                                      class="required">
                            <b-select id="select-edit-department-type" :options="editDepartmentTypes"
                                      v-model="editDepartmentTypeUid"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="Подразделение РЭС" label-for="input-edit-department" class="required">
                            <b-input id="input-edit-department" v-model="editDepartment" @keyup.esc="cancelRecord"
                                     :disabled="getEditControlStatus" maxlength="100"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="Примечание" label-for="textarea-edit-description">
                            <b-textarea id="textarea-edit-description" v-model="editDescription" rows="2"
                                        :disabled="getEditControlStatus" @keyup.esc="cancelRecord" maxlength="500"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="Статус записи" label-for="input-edit-record-status" class="required">
                            <b-select id="input-edit-record-status" :options="editRecordStatuses"
                                      v-model="editRecordStatus" :disabled="!userActionAccessArray['status']"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <hr/>
                <b-button v-show="userActionAccessArray['edit']" type="submit" variant="primary">Сохранить</b-button>
                <b-button type="reset" variant="secondary" class="ml-2">
                    {{userActionAccessArray["edit"] ? 'Отмена': 'Закрыть'}}
                </b-button>
            </b-form>
        </b-card>

        <b-modal ref="modal-search" hide-footer centered title="Расширенный поиск" @hidden="modalHidden">
            <b-alert :show="errModal" :variant="errVariantModal" class="mb-4">{{errTextModal}}</b-alert>
            <b-row>
                <b-col sm="12" v-if="userActionAccessCompany">
                    <b-form-group label="РЭК" label-for="input-AdvSearch-company">
                        <b-select id="input-AdvSearch-company" :options="searchCompanies"
                                  v-model="searchCompanyUid" autofocus
                                  @change="loadSearchDepartmentTypes"
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="12" v-if="userActionAccessRes">
                    <b-form-group label="РЭС" label-for="input-AdvSearch-res">
                        <b-select id="input-AdvSearch-res" :options="searchRes"
                                  v-model="searchResUid"
                                  :disabled="searchCompanyUid===0 && userActionAccessCompany"
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="12">
                    <b-form-group label="Вид подразделения" label-for="input-AdvSearch-department-type">
                        <b-select id="input-AdvSearch-department-type" :options="searchDepartmentTypes"
                                  v-model="searchDepartmentTypeUid"
                                  :disabled="searchCompanyUid===0 && userActionAccessCompany"
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="12">
                    <b-form-group label="Статус записи" label-for="input-AdvSearch-record-status">
                        <b-select id="input-AdvSearch-record-status" :options="searchRecordStatuses"
                                  v-model="searchRecordStatus"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <div>
                <b-button variant="outline-danger" @click="buttonAdvSearchCancelClicked">Сбросить</b-button>
                <b-button variant="secondary" class="ml-2 float-right" @click="buttonAdvSearchCloseClicked">Закрыть
                </b-button>
                <b-button variant="primary" class="float-right" @click="buttonAdvSearchOkClicked">Поиск</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
    import MyToolbar from "@/view/components/MyToolbar";
    import MyToolbarItem from "@/view/components/MyToolbarItem";
    import axios from "axios";

    export default {
        name: "ResDepartments",
        components: {MyToolbar, MyToolbarItem},
        data() {
            return {
                userData: this.$store.getters.getUserData,
                recordCountPerPageArray: this.$store.getters.getRecordCountPerPageArray || [],
                recordCountPerPage: this.$store.getters.getRecordCountPerPage || 20,
                recordCurrentPageNumber: 1,
                recordTotalNumber: 0,

                userActionAccessArray: [],
                userActionAccessCompany: false,
                userActionAccessRes: false,

                loadProcessing: 0,

                editMode: 0,
                addEditTitle: "",
                recordUid: "",
                recordVersion: "",

                err: false,
                errText: "",
                errVariant: "danger",

                errModal: false,
                errTextModal: "",
                errVariantModal: "danger",

                searchQuickFilter: "",
                searchRecordStatus: -1,
                searchCompanyUid: 0,
                searchDepartmentTypeUid: 0,
                searchResUid: "",

                sortMode: 0,    //0-simple, 1-advanced
                sortBy: "Department",
                sortDesc: false,

                searchRecordStatuses: [
                    {'value': -1, 'text': "<все>"},
                    {'value': 0, 'text': "готов"},
                    {'value': 1, 'text': "только чтение"},
                    {'value': 2, 'text': "заблокирован"},
                    {'value': 3, 'text': "на удаление"},
                    {'value': 4, 'text': "в архиве"},
                ],
                searchCompanies: [],
                searchDepartmentTypes: [{'value': 0, 'text': '<все>'}],
                searchRes: [{'value': "", 'text': '<все>'}],

                currentIpAddress: "",

                departmentList: [],
                departmentListFields: [
                    {key: "RowNumber", label: "№", tdClass: "pointer"},
                    {key: "CompanyAlias", label: "РЭК", sortable: true, tdClass: "pointer"},
                    {key: "RES", label: "РЭС", sortable: true, tdClass: "pointer"},
                    {key: "Department", label: "Подразделение РЭС", sortable: true, tdClass: "pointer"},
                    {key: "DepartmentType", label: "Вид подразделения", sortable: true, tdClass: "pointer"},
                    {key: "RecordStatus", label: "Статус", sortable: true, tdClass: "pointer"},
                ],

                editCompanies: [],
                editRes: [],
                editDepartmentTypes: [],
                editRecordStatuses: [],
                recordStatusesForAdd: [
                    {'value': 0, 'text': "готов"},
                    {'value': 1, 'text': "только чтение"},
                ],
                recordStatusesForEdit: [
                    {'value': 0, 'text': "готов"},
                    {'value': 1, 'text': "только чтение"},
                    {'value': 2, 'text': "заблокирован"},
                    {'value': 3, 'text': "на удаление"},
                    {'value': 4, 'text': "в архиве"},
                ],

                editCompanyUid: 0,
                editResUid: "",
                editDepartmentTypeUid: 0,
                editDepartment: "",
                editDescription: "",
                editRecordStatus: -1,

                currentRecordStatus: -1,
            }
        },
        created() {
            window.addEventListener('keydown', (e) => {
                if (e.key === 'Insert' && !e.ctrlKey && !e.altKey && !e.shiftKey) {
                    this.buttonAddClicked()
                }
            });
            this.userActionAccessArray = this.getUserActionAccessArray("RefsDepartments", this.userData.UserAccess)
            this.userActionAccessCompany = this.getUserDataAccess("RefsCompanies", this.userData.UserAccess)
            this.userActionAccessRes = this.getUserDataAccess("RefsRES", this.userData.UserAccess)
        },
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [
                {title: "Справочники", route: "res-departments"},
                {title: "Подразделения РЭС"}
            ]);

            this.loadDepartmentList()
            if (this.userData.UserGroupUid === 1) this.loadCompanies()

            //If not Admin - delete Company from the list
            if (this.userData.UserGroupUid !== 1) {
                let ind = this.departmentListFields.findIndex(item => item.key.toLowerCase() === "companyalias");
                if (ind >= 0)
                    this.departmentListFields.splice(ind, 1)
            }
            //If no access to Res - delete Res from the list
            if (!this.userActionAccessRes) {
                let ind = this.departmentListFields.findIndex(item => item.key.toLowerCase() === "res");
                if (ind >= 0)
                    this.departmentListFields.splice(ind, 1)
            }

            //If no access to archive
            if (!this.userActionAccessArray['archive']) {
                let ind = this.searchRecordStatuses.findIndex(item => item.value === 4);
                if (ind >= 0)
                    this.searchRecordStatuses.splice(ind, 1)
            }

            if (!this.userActionAccessCompany) {
                this.loadEditDepartmentTypes()
                this.loadSearchDepartmentTypes()
            }

            this.$nextTick(() => {
                this.$refs.inputQuickFilter.$el.focus()
            })
        },
        methods: {
            errTextHide() {
                this.err = false
                this.errText = ""
            },
            errTextShow(msg, variant = "danger", withScroll = true) {
                if (withScroll)
                    window.scrollTo(0, 0)
                this.errText = msg
                this.errVariant = variant
                this.err = true
            },
            errTextHideModal() {
                this.errModal = false
                this.errTextModal = ""
            },
            errTextShowModal(msg, variant = "danger", withScroll = true) {
                if (withScroll)
                    window.scrollTo(0, 0)
                this.errTextModal = msg
                this.errVariantModal = variant
                this.errModal = true
            },
            loadCompanies() {
                this.editCompanies = []
                this.searchCompanies = [{'value': 0, 'text': "<все>"}]

                axios.post("/ws/ws.svc/GetRefsCompaniesArray", {
                        'Session_UID': this.userData.Session_UID,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShow("Неверный формат ответа.")
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.data.forEach(item => {
                                            this.editCompanies.push({'value': item.UID, 'text': item.Alias})
                                            this.searchCompanies.push({'value': item.UID, 'text': item.Alias})
                                        })
                                    }
                                } else {
                                    this.errTextShow(resp.data.response.toString())
                                }
                            }
                        }
                    )
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")")
                    })
            },
            loadSearchDepartmentTypes() {
                this.loadSearchRes()

                this.searchDepartmentTypeUid = 0
                this.searchDepartmentTypes = [{'value': 0, 'text': '<все>'}]
                this.errTextHideModal()

                //if (this.searchCompanyUid === 0 && this.userActionAccessCompany) return

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetRefsRESDepartmentTypesArray", {
                        'Session_UID': this.userData.Session_UID,
                        'F_Company_UID': this.searchCompanyUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShowModal("Неверный формат ответа.")
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.forEach(item => {
                                            this.searchDepartmentTypes.push({
                                                'value': item.UID,
                                                'text': item.DepartmentType
                                            })
                                        })
                                    }
                                } else {
                                    this.errTextShowModal(resp.data.response.toString())
                                }
                            }
                            this.loadProcessing--
                        }
                    )
                    .catch(err => {
                        this.loadProcessing--
                        this.errTextShowModal("Ошибка при получении данных (" + err.message + ")")
                    })
            },
            loadSearchRes() {
                this.searchResUid = ""
                this.searchRes = [{'value': "", 'text': '<все>'}]
                this.errTextHideModal()

                if (!this.userActionAccessRes) return

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetRefsRESArray", {
                        'Session_UID': this.userData.Session_UID,
                        'F_Company_UID': this.searchCompanyUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShowModal("Неверный формат ответа.")
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.forEach(item => {
                                            this.searchRes.push({
                                                'value': item.UID,
                                                'text': item.RES
                                            })
                                        })
                                    }
                                } else {
                                    this.errTextShowModal(resp.data.response.toString())
                                }
                            }
                            this.loadProcessing--
                        }
                    )
                    .catch(err => {
                        this.loadProcessing--
                        this.errTextShowModal("Ошибка при получении данных (" + err.message + ")")
                    })
            },
            loadEditRes() {
                this.editRes = []
                this.errTextHideModal()

                axios.post("/ws/ws.svc/GetRefsRESArray", {
                        'Session_UID': this.userData.Session_UID,
                        'F_Company_UID': this.editCompanyUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            this.editRes = []
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShowModal("Неверный формат ответа.")
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.forEach(item => {
                                            this.editRes.push({
                                                'value': item.UID,
                                                'text': item.RES
                                            })
                                        })
                                    }
                                } else {
                                    this.errTextShowModal(resp.data.response.toString())
                                }
                            }
                        }
                    )
                    .catch(err => {
                        this.errTextShowModal("Ошибка при получении данных (" + err.message + ")")
                    })
            },
            loadEditDepartmentTypes() {
                this.loadEditRes()

                this.editDepartmentTypes = []

                axios.post("/ws/ws.svc/GetRefsRESDepartmentTypesArray", {
                        'Session_UID': this.userData.Session_UID,
                        'F_Company_UID': this.editCompanyUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShow("Неверный формат ответа.")
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.forEach(item => {
                                            this.editDepartmentTypes.push({'value': item.UID, 'text': item.DepartmentType})
                                        })
                                    }
                                } else {
                                    this.errTextShow(resp.data.response.toString())
                                }
                            }
                        }
                    )
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")")
                    })
            },
            loadDepartmentList() {
                this.errTextHide()

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetRefsRESDepartments", {
                        'Session_UID': this.userData.Session_UID,
                        'Page': this.recordCurrentPageNumber,
                        'RecordsPerPage': this.recordCountPerPage,
                        'SortField': this.sortBy,
                        'SortMode': (this.sortDesc ? 1 : 0),
                        'F_Department': this.searchQuickFilter,
                        'F_Company_UID': this.searchCompanyUid,
                        'F_RES_UID': this.searchResUid,
                        'F_DepartmentType_UID': this.searchDepartmentTypeUid,
                        'F_RS': this.searchRecordStatus,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response) ||
                            this.isUndefined(resp.data.data) || this.isUndefined(resp.data.meta)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                if (resp.data.data.toString().length > 0) {
                                    this.departmentList = JSON.parse(resp.data.data)
                                    if (!this.isUndefined(resp.data.meta.TotalRecordsAmount)) {
                                        this.recordTotalNumber = resp.data.meta.TotalRecordsAmount
                                    } else {
                                        this.errTextShow("Ошибка при получении общего кол-ва записей.", "danger", true)
                                    }
                                } else {
                                    this.recordTotalNumber = 0
                                    this.departmentList = []

                                }
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }
                        this.loadProcessing--
                    })
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                        this.loadProcessing--
                    })
            },
            sortChanged(e) {
                this.sortBy = e.sortBy
                this.sortDesc = e.sortDesc
                this.loadDepartmentList()
            },
            buttonSearchClicked() {
                this.recordCurrentPageNumber = 1
                this.loadDepartmentList()
            },
            buttonAdvSearchShowClicked() {
                this.$refs['modal-search'].show()
            },
            buttonAdvSearchOkClicked() {
                if (this.searchCompanyUid !== 0 || this.searchDepartmentTypeUid !== 0 || this.searchRecordStatus !== -1) {
                    this.sortMode = 1
                    this.searchQuickFilter = ""
                } else {
                    this.sortMode = 0
                }

                this.recordCurrentPageNumber = 1
                this.loadDepartmentList()
                this.$refs['modal-search'].hide()
            },
            buttonAdvSearchCancelClicked() {
                this.sortMode = 0
                this.searchCompanyUid = 0
                this.searchDepartmentTypeUid = 0
                this.searchRecordStatus = -1
                this.recordCurrentPageNumber = 1
                this.$refs['modal-search'].hide()
                this.loadSearchDepartmentTypes()
                this.loadDepartmentList()
            },
            buttonAdvSearchCloseClicked() {
                this.$refs['modal-search'].hide()
            },

            buttonRefreshClicked() {
                this.loadDepartmentList()
            },
            buttonAddClicked() {
                this.errTextHide()
                this.recordUid = ""
                this.recordVersion = ""
                this.addEditTitle = "Добавление записи"
                this.editDepartment = ""
                this.editDescription = ""
                this.editRecordStatus = 0
                this.currentRecordStatus = 0
                this.editRecordStatuses = this.recordStatusesForAdd
                this.editResUid = ""
                this.editDepartmentTypeUid = 0

                if (this.userActionAccessCompany) {
                    this.editCompanyUid = 0
                }

                this.editMode = 1

                this.$nextTick(() => {
                    if (!this.isUndefined(this.$refs.selectEditCompany))
                        this.$refs.selectEditCompany.$el.focus()
                    else
                        this.$refs.selectEditRes.$el.focus()
                })
            },
            tableRowClicked(item) {
                this.errTextHide()
                this.recordUid = item.UID
                this.recordVersion = ""
                this.addEditTitle = ""
                this.editDepartment = ""
                this.editDescription = ""
                this.editRecordStatus = -1
                this.currentRecordStatus = -1
                this.editResUid = ""
                this.editDepartmentTypeUid = 0

                this.editRecordStatuses = this.recordStatusesForEdit

                if (this.userActionAccessCompany) {
                    this.editCompanyUid = 0
                }

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetRefsRESDepartment", {
                        'Session_UID': this.userData.Session_UID,
                        'F_UID': this.recordUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                if (resp.data.data.toString().length > 0) {
                                    let result = (JSON.parse(resp.data.data))

                                    this.editCompanyUid = result.Company_UID ? parseInt(result.Company_UID.toString()) : 0
                                    this.editResUid = result.RES_UID.toString()
                                    this.editDepartmentTypeUid = parseInt(result.RESDepartmentType_UID.toString())
                                    this.editDepartment = result.Department.toString()
                                    this.editDescription = result.Description.toString()
                                    this.editRecordStatus = parseInt(result.RS.toString())
                                    this.recordVersion = result.RVV.toString()

                                    this.currentRecordStatus = this.editRecordStatus

                                    if (this.userActionAccessArray["edit"])
                                        this.addEditTitle = "Изменение записи: " + this.editDepartment
                                    else
                                        this.addEditTitle = "Просмотр записи: " + this.editDepartment

                                    if (this.userActionAccessCompany) {
                                        this.loadEditDepartmentTypes()
                                    }

                                    this.$nextTick(() => {
                                        this.$refs.selectEditRes.$el.focus()
                                    })
                                } else {
                                    this.errTextShow("Запись не найдена. Пожалуйста, обновите страницу.", "danger", true)
                                }
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }

                        this.editMode = 1
                        this.loadProcessing--
                        this.$nextTick(() => {
                            this.$refs.selectEditRes.$el.focus()
                        })
                    })
                    .catch(err => {
                        this.editMode = 1
                        this.loadProcessing--
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                    })
            },
            saveRecord() {
                this.errTextHide()

                if (this.userData.UserGroupUid === 1 && this.editCompanyUid === 0) {
                    this.errTextShow("Выберите РЭК.", "info", true)
                    return
                }
                if (this.editResUid === "") {
                    this.errTextShow("Выберите РЭС.", "info", true)
                    return
                }
                if (this.editDepartmentTypeUid === 0) {
                    this.errTextShow("Выберите Вид подразделения.", "info", true)
                    return
                }
                if (this.editDepartment === "") {
                    this.errTextShow("Введите подразделение.", "info", true)
                    return
                }
                if (this.editRecordStatus === -1) {
                    this.errTextShow("Выберите статус записи.", "info", true)
                    return
                }

                this.loadProcessing++
                axios.post("/ws/ws.svc/UpdateRefsRESDepartment", {
                        'Session_UID': this.userData.Session_UID,
                        'R_UID': this.recordUid,
                        'R_Company_UID': this.editCompanyUid,
                        'R_RES_UID': this.editResUid,
                        'R_Department': this.editDepartment,
                        'R_DepartmentType_UID': this.editDepartmentTypeUid,
                        'R_Description': this.editDescription,
                        'R_RS': this.editRecordStatus,
                        'R_RV': this.recordVersion,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                this.loadDepartmentList()
                                this.editMode = 0
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }

                        this.loadProcessing--
                    })
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                        this.loadProcessing--
                    })
            },
            cancelRecord() {
                this.errTextHide()
                this.editMode = 0
            },
            putCurrentIpAddress() {
                if (this.currentIpAddress !== "") {
                    this.editIpAddresses = this.currentIpAddress
                }
                this.editIpBinded = true
            },
            modalHidden() {
                this.$nextTick(() => {
                    this.$refs.inputQuickFilter.$el.focus()
                })
            }
        },
        computed: {
            getEditControlStatus: function () {
                return (!this.userActionAccessArray["edit"] || this.currentRecordStatus > 0)
            },
        },
        watch: {
            loadProcessing: function () {
                this.$store.commit('set', ["showSpinner", this.loadProcessing > 0])
            },
        }
    }
</script>

<style scoped>

</style>